import {
  format,
  formatDistance,
  /* formatRelative, */ isToday,
} from "date-fns";

/**
 * Format a date for display
 * @param date Date to format
 * @returns Formatted date string
 */
export const formatDate = (date: Date | string | number): string => {
  const dateObj = new Date(date);

  if (isToday(dateObj)) {
    return `Today, ${format(dateObj, "h:mm a")}`;
  }

  return format(dateObj, "MMM d, yyyy");
};

/**
 * Format a date as a relative time (e.g., "2 days ago")
 * @param date Date to format
 * @returns Formatted relative date string
 */
export const formatRelativeDate = (date: Date | string | number): string => {
  const dateObj = new Date(date);
  return formatDistance(dateObj, new Date(), { addSuffix: true });
};

/**
 * Format a date with time
 * @param date Date to format
 * @returns Formatted date string with time
 */
export const formatDateTime = (date: Date | string | number): string => {
  const dateObj = new Date(date);
  return format(dateObj, "MMM d, yyyy h:mm a");
};

/**
 * Format a date for input fields (YYYY-MM-DD)
 * @param date Date to format
 * @returns Formatted date string for input
 */
export const formatDateForInput = (date: Date | string | number): string => {
  const dateObj = new Date(date);
  return format(dateObj, "yyyy-MM-dd");
};
